import type {
  User,
  Shift,
  Room,
  RoomBed,
  BedBooking,
  Guest,
  Booking,
  Payment,
  InventoryItem,
  StockTransaction,
  Vendor,
  PurchaseOrder,
  GoodsReceivedNote,
  CanteenItem,
  CanteenBill,
  ActivityLog,
} from './data';

export const demoUsers: User[] = [
  {
    id: 'usr-001',
    email: 'admin@hotelpro.com',
    password: 'admin123',
    full_name: 'Rajesh Sharma',
    role: 'admin',
    phone: '+91 98765 43210',
    created_at: '2025-01-15T10:00:00Z',
  },
  {
    id: 'usr-002',
    email: 'manager@hotelpro.com',
    password: 'manager123',
    full_name: 'Vikram Singh',
    role: 'manager',
    phone: '+91 98765 43211',
    active_shift: 'shift-002',
    created_at: '2025-02-01T09:00:00Z',
  },
  {
    id: 'usr-003',
    email: 'priya@hotelpro.com',
    password: 'priya123',
    full_name: 'Priya Patel',
    role: 'receptionist',
    phone: '+91 98765 43212',
    created_at: '2025-03-10T08:30:00Z',
  },
  {
    id: 'usr-004',
    email: 'amit@hotelpro.com',
    password: 'amit123',
    full_name: 'Amit Kumar',
    role: 'receptionist',
    phone: '+91 98765 43213',
    created_at: '2025-04-05T11:00:00Z',
  },
  {
    id: 'usr-005',
    email: 'housekeeping@hotelpro.com',
    password: 'house123',
    full_name: 'Sunita Devi',
    role: 'housekeeping',
    phone: '+91 98765 43214',
    created_at: '2025-05-20T07:00:00Z',
  },
  {
    id: 'usr-006',
    email: 'accountant@hotelpro.com',
    password: 'account123',
    full_name: 'Deepak Agarwal',
    role: 'accountant',
    phone: '+91 98765 43215',
    created_at: '2025-06-01T09:00:00Z',
  },
];

export const demoShifts: Shift[] = [
  {
    id: 'shift-001',
    name: 'Morning Shift',
    start_time: '06:00',
    end_time: '14:00',
    assigned_to: 'usr-004',
    opening_balance: 5000,
    closing_balance: 12500,
    collections: 7500,
    cash_collections: 3200,
    card_collections: 2800,
    upi_collections: 1500,
    canteen_collections: 924,
    canteen_cash: 483,
    canteen_card: 0,
    canteen_upi: 441,
    handover_notes: 'All rooms cleaned. One guest requested late checkout.',
    status: 'closed',
    created_at: '2026-05-15T06:00:00Z',
  },
  {
    id: 'shift-002',
    name: 'Evening Shift',
    start_time: '14:00',
    end_time: '22:00',
    assigned_to: 'usr-003',
    opening_balance: 12500,
    closing_balance: 0,
    collections: 0,
    cash_collections: 0,
    card_collections: 0,
    upi_collections: 0,
    canteen_collections: 0,
    canteen_cash: 0,
    canteen_card: 0,
    canteen_upi: 0,
    handover_notes: 'Shift started, cash taken over from morning shift.',
    status: 'active',
    created_at: '2026-05-15T14:00:00Z',
  },
  {
    id: 'shift-003',
    name: 'Night Shift',
    start_time: '22:00',
    end_time: '06:00',
    assigned_to: 'usr-004',
    opening_balance: 0,
    closing_balance: 0,
    collections: 0,
    cash_collections: 0,
    card_collections: 0,
    upi_collections: 0,
    canteen_collections: 0,
    canteen_cash: 0,
    canteen_card: 0,
    canteen_upi: 0,
    handover_notes: '',
    status: 'closed',
    created_at: '2026-05-14T22:00:00Z',
  },
];

export const demoRooms: Room[] = [
  { id: 'room-101', room_number: '101', floor: 1, category: 'Standard AC', room_type: 'private', tariff: 1800, per_bed_price: 0, total_beds: 1, description: 'Cozy room with city view', photos: [], status: 'occupied', max_occupancy: 2 },
  { id: 'room-102', room_number: '102', floor: 1, category: 'Standard AC', room_type: 'private', tariff: 1800, per_bed_price: 0, total_beds: 1, description: 'Cozy room with city view', photos: [], status: 'available', max_occupancy: 2 },
  { id: 'room-103', room_number: '103', floor: 1, category: 'Deluxe AC', room_type: 'private', tariff: 2500, per_bed_price: 0, total_beds: 1, description: 'Spacious with king bed and balcony', photos: [], status: 'cleaning', max_occupancy: 3 },
  { id: 'room-104', room_number: '104', floor: 1, category: 'Deluxe AC', room_type: 'private', tariff: 2500, per_bed_price: 0, total_beds: 1, description: 'Spacious with king bed and balcony', photos: [], status: 'occupied', max_occupancy: 3 },
  { id: 'room-201', room_number: '201', floor: 2, category: 'Suite', room_type: 'private', tariff: 4500, per_bed_price: 0, total_beds: 1, description: 'Premium suite with living area and jacuzzi', photos: [], status: 'available', max_occupancy: 4 },
  { id: 'room-202', room_number: '202', floor: 2, category: 'Suite', room_type: 'private', tariff: 4500, per_bed_price: 0, total_beds: 1, description: 'Premium suite with living area and jacuzzi', photos: [], status: 'occupied', max_occupancy: 4 },
  { id: 'room-203', room_number: '203', floor: 2, category: 'Standard Non-AC', room_type: 'private', tariff: 1200, per_bed_price: 0, total_beds: 1, description: 'Budget room with fan and shared balcony', photos: [], status: 'available', max_occupancy: 2 },
  { id: 'room-204', room_number: '204', floor: 2, category: 'Standard Non-AC', room_type: 'private', tariff: 1200, per_bed_price: 0, total_beds: 1, description: 'Budget room with fan and shared balcony', photos: [], status: 'maintenance', max_occupancy: 2 },
  { id: 'room-301', room_number: '301', floor: 3, category: 'Deluxe AC', room_type: 'private', tariff: 2800, per_bed_price: 0, total_beds: 1, description: 'Luxury deluxe with panoramic view', photos: [], status: 'available', max_occupancy: 3 },
  { id: 'room-302', room_number: '302', floor: 3, category: 'Deluxe AC', room_type: 'private', tariff: 2800, per_bed_price: 0, total_beds: 1, description: 'Luxury deluxe with panoramic view', photos: [], status: 'occupied', max_occupancy: 3 },
  { id: 'room-303', room_number: '303', floor: 3, category: 'Standard AC', room_type: 'private', tariff: 2000, per_bed_price: 0, total_beds: 1, description: 'Modern standard room', photos: [], status: 'available', max_occupancy: 2 },
  { id: 'room-304', room_number: '304', floor: 3, category: 'Standard AC', room_type: 'private', tariff: 2000, per_bed_price: 0, total_beds: 1, description: 'Modern standard room', photos: [], status: 'cleaning', max_occupancy: 2 },
  { id: 'room-401', room_number: '401', floor: 4, category: 'Suite', room_type: 'private', tariff: 5000, per_bed_price: 0, total_beds: 1, description: 'Presidential suite with private terrace', photos: [], status: 'available', max_occupancy: 5 },
  { id: 'room-402', room_number: '402', floor: 4, category: 'Suite', room_type: 'private', tariff: 5000, per_bed_price: 0, total_beds: 1, description: 'Presidential suite with private terrace', photos: [], status: 'occupied', max_occupancy: 5 },
  { id: 'room-403', room_number: '403', floor: 4, category: 'Standard AC', room_type: 'private', tariff: 1900, per_bed_price: 0, total_beds: 1, description: 'Executive standard room', photos: [], status: 'available', max_occupancy: 2 },
  { id: 'room-404', room_number: '404', floor: 4, category: 'Deluxe AC', room_type: 'private', tariff: 2600, per_bed_price: 0, total_beds: 1, description: 'Executive deluxe room', photos: [], status: 'occupied', max_occupancy: 3 },
  { id: 'room-501', room_number: '501', floor: 5, category: 'Standard Non-AC', room_type: 'private', tariff: 1300, per_bed_price: 0, total_beds: 1, description: 'Economy room with basic amenities', photos: [], status: 'available', max_occupancy: 2 },
  { id: 'room-502', room_number: '502', floor: 5, category: 'Standard Non-AC', room_type: 'private', tariff: 1300, per_bed_price: 0, total_beds: 1, description: 'Economy room with basic amenities', photos: [], status: 'available', max_occupancy: 2 },
  { id: 'room-503', room_number: '503', floor: 5, category: 'Standard AC', room_type: 'private', tariff: 2200, per_bed_price: 0, total_beds: 1, description: 'Premium standard with mountain view', photos: [], status: 'occupied', max_occupancy: 2 },
  { id: 'room-504', room_number: '504', floor: 5, category: 'Deluxe AC', room_type: 'private', tariff: 3000, per_bed_price: 0, total_beds: 1, description: 'Premium deluxe with mountain view', photos: [], status: 'available', max_occupancy: 3 },
  // Shared & Dormitory Rooms
  { id: 'room-D101', room_number: 'D101', floor: 1, category: 'Dormitory', room_type: 'dormitory', tariff: 5000, per_bed_price: 600, total_beds: 10, description: 'Mixed dormitory with AC, locker, attached bathroom', photos: [], status: 'available', max_occupancy: 10 },
  { id: 'room-D102', room_number: 'D102', floor: 1, category: 'Dormitory', room_type: 'dormitory', tariff: 4000, per_bed_price: 500, total_beds: 8, description: 'Female dormitory with AC, locker, attached bathroom', photos: [], status: 'available', max_occupancy: 8 },
  { id: 'room-D201', room_number: 'D201', floor: 2, category: 'Dormitory', room_type: 'dormitory', tariff: 3500, per_bed_price: 400, total_beds: 6, description: 'Budget dormitory with fan, shared bathroom', photos: [], status: 'available', max_occupancy: 6 },
  { id: 'room-SH01', room_number: 'SH01', floor: 3, category: 'Shared Room', room_type: 'shared', tariff: 2000, per_bed_price: 1000, total_beds: 3, description: 'Shared twin room with separate beds, common TV', photos: [], status: 'available', max_occupancy: 3 },
];

export const demoGuests: Guest[] = [
  {
    id: 'guest-001',
    full_name: 'Amitabh Verma',
    phone: '+91 99887 77665',
    email: 'amitabh.v@email.com',
    id_proof_type: 'Aadhaar',
    id_proof_number: '1234 5678 9012',
    address: '42, MG Road, Bengaluru, Karnataka 560001',
    is_repeating: true,
    total_spend: 28700,
    created_at: '2025-08-10T14:30:00Z',
  },
  {
    id: 'guest-002',
    full_name: 'Sunita Devi',
    phone: '+91 88776 66554',
    email: 'sunita.d@email.com',
    id_proof_type: 'Passport',
    id_proof_number: 'A1234567',
    address: '15, Lake View Apartments, Mumbai, Maharashtra 400001',
    is_repeating: false,
    total_spend: 4500,
    created_at: '2026-05-10T11:00:00Z',
  },
  {
    id: 'guest-003',
    full_name: 'Ravi Shankar',
    phone: '+91 77665 55443',
    email: 'ravi.shankar@email.com',
    id_proof_type: 'Driving License',
    id_proof_number: 'DL-987654321',
    address: '88, Park Street, Kolkata, West Bengal 700016',
    is_repeating: true,
    total_spend: 15600,
    created_at: '2025-11-20T09:15:00Z',
  },
  {
    id: 'guest-004',
    full_name: 'Neha Gupta',
    phone: '+91 66554 44332',
    email: 'neha.g@email.com',
    id_proof_type: 'Aadhaar',
    id_proof_number: '9876 5432 1098',
    address: '7, Green Valley, Hyderabad, Telangana 500032',
    is_repeating: false,
    total_spend: 7200,
    created_at: '2026-05-14T16:45:00Z',
  },
  {
    id: 'guest-005',
    full_name: 'Mohammed Ali',
    phone: '+91 55443 33221',
    email: 'm.ali@email.com',
    id_proof_type: 'Passport',
    id_proof_number: 'B7654321',
    address: '23, Ocean Drive, Chennai, Tamil Nadu 600004',
    is_repeating: false,
    total_spend: 3500,
    created_at: '2026-05-15T08:00:00Z',
  },
  {
    id: 'guest-006',
    full_name: 'Deepa Krishnan',
    phone: '+91 44332 22110',
    email: 'deepa.k@email.com',
    id_proof_type: 'Aadhaar',
    id_proof_number: '4567 8901 2345',
    address: '33, Hill Top, Kochi, Kerala 682011',
    is_repeating: true,
    total_spend: 42000,
    created_at: '2024-12-05T10:00:00Z',
  },
];

export const demoRoomBeds: RoomBed[] = [
  // D101 - 10 Beds (4 occupied by bed bookings)
  { id: 'bed-d101-1', room_id: 'room-D101', bed_number: 1, status: 'available' },
  { id: 'bed-d101-2', room_id: 'room-D101', bed_number: 2, status: 'occupied' },
  { id: 'bed-d101-3', room_id: 'room-D101', bed_number: 3, status: 'occupied' },
  { id: 'bed-d101-4', room_id: 'room-D101', bed_number: 4, status: 'occupied' },
  { id: 'bed-d101-5', room_id: 'room-D101', bed_number: 5, status: 'reserved' },
  { id: 'bed-d101-6', room_id: 'room-D101', bed_number: 6, status: 'available' },
  { id: 'bed-d101-7', room_id: 'room-D101', bed_number: 7, status: 'available' },
  { id: 'bed-d101-8', room_id: 'room-D101', bed_number: 8, status: 'cleaning' },
  { id: 'bed-d101-9', room_id: 'room-D101', bed_number: 9, status: 'available' },
  { id: 'bed-d101-10', room_id: 'room-D101', bed_number: 10, status: 'maintenance' },
  // D102 - 8 Beds
  { id: 'bed-d102-1', room_id: 'room-D102', bed_number: 1, status: 'available' },
  { id: 'bed-d102-2', room_id: 'room-D102', bed_number: 2, status: 'available' },
  { id: 'bed-d102-3', room_id: 'room-D102', bed_number: 3, status: 'available' },
  { id: 'bed-d102-4', room_id: 'room-D102', bed_number: 4, status: 'occupied' },
  { id: 'bed-d102-5', room_id: 'room-D102', bed_number: 5, status: 'available' },
  { id: 'bed-d102-6', room_id: 'room-D102', bed_number: 6, status: 'available' },
  { id: 'bed-d102-7', room_id: 'room-D102', bed_number: 7, status: 'available' },
  { id: 'bed-d102-8', room_id: 'room-D102', bed_number: 8, status: 'available' },
  // D201 - 6 Beds
  { id: 'bed-d201-1', room_id: 'room-D201', bed_number: 1, status: 'available' },
  { id: 'bed-d201-2', room_id: 'room-D201', bed_number: 2, status: 'available' },
  { id: 'bed-d201-3', room_id: 'room-D201', bed_number: 3, status: 'occupied' },
  { id: 'bed-d201-4', room_id: 'room-D201', bed_number: 4, status: 'available' },
  { id: 'bed-d201-5', room_id: 'room-D201', bed_number: 5, status: 'available' },
  { id: 'bed-d201-6', room_id: 'room-D201', bed_number: 6, status: 'cleaning' },
  // SH01 - 3 Beds (shared room)
  { id: 'bed-sh01-1', room_id: 'room-SH01', bed_number: 1, status: 'occupied' },
  { id: 'bed-sh01-2', room_id: 'room-SH01', bed_number: 2, status: 'available' },
  { id: 'bed-sh01-3', room_id: 'room-SH01', bed_number: 3, status: 'available' },
];

export const demoBedBookings: BedBooking[] = [
  {
    id: 'bb-001',
    booking_id: 'HOTEL-20260515-B01',
    bed_ids: ['bed-d101-2', 'bed-d101-3', 'bed-d101-4'],
    guest_id: 'guest-003',
    checkin_date: '2026-05-14T12:00:00Z',
    checkout_date: '2026-05-16T11:00:00Z',
    status: 'checked_in',
  },
  {
    id: 'bb-002',
    booking_id: 'HOTEL-20260515-B02',
    bed_ids: ['bed-d102-4'],
    guest_id: 'guest-005',
    checkin_date: '2026-05-15T08:00:00Z',
    checkout_date: '2026-05-16T11:00:00Z',
    status: 'checked_in',
  },
  {
    id: 'bb-003',
    booking_id: 'HOTEL-20260515-B03',
    bed_ids: ['bed-d101-5'],
    guest_id: 'guest-004',
    checkin_date: '2026-05-16T14:00:00Z',
    checkout_date: '2026-05-18T11:00:00Z',
    status: 'confirmed',
  },
  {
    id: 'bb-004',
    booking_id: 'HOTEL-20260515-B04',
    bed_ids: ['bed-d201-3'],
    guest_id: 'guest-001',
    checkin_date: '2026-05-13T12:00:00Z',
    checkout_date: '2026-05-15T11:00:00Z',
    status: 'checked_in',
  },
  {
    id: 'bb-005',
    booking_id: 'HOTEL-20260515-B05',
    bed_ids: ['bed-sh01-1'],
    guest_id: 'guest-006',
    checkin_date: '2026-05-14T14:00:00Z',
    checkout_date: '2026-05-17T11:00:00Z',
    status: 'checked_in',
  },
];

export const demoBookings: Booking[] = [
  {
    id: 'bk-001',
    booking_id: 'HOTEL-20260515-001',
    guest_id: 'guest-001',
    room_id: 'room-101',
    booking_type: 'walk_in',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-15T12:00:00Z',
    check_out: '2026-05-17T11:00:00Z',
    status: 'checked_in',
    deposit: 1000,
    total_amount: 4600,
    pending_amount: 0,
    extra_charges: [{ name: 'Extra Bed', amount: 500 }],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-15T12:05:00Z',
  },
  {
    id: 'bk-002',
    booking_id: 'HOTEL-20260514-002',
    guest_id: 'guest-002',
    room_id: 'room-104',
    booking_type: 'advance',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-14T14:00:00Z',
    check_out: '2026-05-16T11:00:00Z',
    status: 'checked_in',
    deposit: 2000,
    total_amount: 5200,
    pending_amount: 0,
    extra_charges: [{ name: 'Room Service', amount: 350 }],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-10T09:00:00Z',
  },
  {
    id: 'bk-003',
    booking_id: 'HOTEL-20260515-003',
    guest_id: 'guest-005',
    room_id: 'room-102',
    booking_type: 'walk_in',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-15T08:30:00Z',
    check_out: '2026-05-15T20:00:00Z',
    status: 'checked_in',
    deposit: 0,
    total_amount: 1800,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-15T08:35:00Z',
  },
  {
    id: 'bk-004',
    booking_id: 'HOTEL-20260512-004',
    guest_id: 'guest-003',
    room_id: 'room-202',
    booking_type: 'pre_booking',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-12T13:00:00Z',
    check_out: '2026-05-15T11:00:00Z',
    status: 'checked_out',
    deposit: 0,
    total_amount: 13500,
    pending_amount: 0,
    extra_charges: [{ name: 'Laundry', amount: 200 }, { name: 'Extra Person', amount: 400 }],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-05T15:00:00Z',
  },
  {
    id: 'bk-005',
    booking_id: 'HOTEL-20260515-005',
    guest_id: 'guest-004',
    room_id: 'room-302',
    booking_type: 'online',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-15T15:00:00Z',
    check_out: '2026-05-18T11:00:00Z',
    status: 'checked_in',
    deposit: 1500,
    total_amount: 8400,
    pending_amount: 4200,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-08T10:00:00Z',
  },
  {
    id: 'bk-006',
    booking_id: 'HOTEL-20260510-006',
    guest_id: 'guest-006',
    room_id: 'room-402',
    booking_type: 'advance',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-10T12:00:00Z',
    check_out: '2026-05-15T11:00:00Z',
    status: 'checked_out',
    deposit: 5000,
    total_amount: 25000,
    pending_amount: 0,
    extra_charges: [{ name: 'Parking', amount: 300 }, { name: 'Room Service', amount: 1200 }],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-04-28T14:00:00Z',
  },
  {
    id: 'bk-007',
    booking_id: 'HOTEL-20260516-007',
    guest_id: 'guest-001',
    room_id: 'room-201',
    booking_type: 'advance',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-16T14:00:00Z',
    check_out: '2026-05-18T11:00:00Z',
    status: 'confirmed',
    deposit: 2000,
    total_amount: 9000,
    pending_amount: 7000,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-12T11:00:00Z',
  },
  {
    id: 'bk-008',
    booking_id: 'HOTEL-20260508-008',
    guest_id: 'guest-002',
    room_id: 'room-304',
    booking_type: 'walk_in',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-08T12:00:00Z',
    check_out: '2026-05-14T11:00:00Z',
    status: 'checked_out',
    deposit: 0,
    total_amount: 15600,
    pending_amount: 0,
    extra_charges: [{ name: 'Extra Bed', amount: 500 }],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-08T12:05:00Z',
  },
  {
    id: 'bk-009',
    booking_id: 'HOTEL-20260509-009',
    guest_id: 'guest-003',
    room_id: 'room-503',
    booking_type: 'pre_booking',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-09T13:00:00Z',
    check_out: '2026-05-15T11:00:00Z',
    status: 'checked_out',
    deposit: 3000,
    total_amount: 13200,
    pending_amount: 0,
    extra_charges: [{ name: 'Laundry', amount: 150 }],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-04-30T16:00:00Z',
  },
  {
    id: 'bk-010',
    booking_id: 'HOTEL-20260511-010',
    guest_id: 'guest-006',
    room_id: 'room-404',
    booking_type: 'online',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-11T14:00:00Z',
    check_out: '2026-05-15T11:00:00Z',
    status: 'checked_out',
    deposit: 4000,
    total_amount: 10400,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-01T09:00:00Z',
  },
  {
    id: 'bk-011',
    booking_id: 'HOTEL-20260513-011',
    guest_id: 'guest-005',
    room_id: 'room-101',
    booking_type: 'walk_in',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-13T12:00:00Z',
    check_out: '2026-05-14T11:00:00Z',
    status: 'checked_out',
    deposit: 0,
    total_amount: 1800,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-13T12:05:00Z',
  },
  {
    id: 'bk-012',
    booking_id: 'HOTEL-20260515-012',
    guest_id: 'guest-004',
    room_id: 'room-504',
    booking_type: 'advance',
    is_bed_booking: false,
    bed_ids: [],
    bed_count: 0,
    check_in: '2026-05-15T16:00:00Z',
    check_out: '2026-05-17T11:00:00Z',
    status: 'confirmed',
    deposit: 1500,
    total_amount: 6000,
    pending_amount: 4500,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-10T14:00:00Z',
  },
  // Bed Booking records
  {
    id: 'bk-013',
    booking_id: 'HOTEL-20260515-B01',
    guest_id: 'guest-003',
    room_id: 'room-D101',
    booking_type: 'walk_in',
    is_bed_booking: true,
    bed_ids: ['bed-d101-2', 'bed-d101-3', 'bed-d101-4'],
    bed_count: 3,
    check_in: '2026-05-14T12:00:00Z',
    check_out: '2026-05-16T11:00:00Z',
    status: 'checked_in',
    deposit: 500,
    total_amount: 3600,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-14T12:05:00Z',
  },
  {
    id: 'bk-014',
    booking_id: 'HOTEL-20260515-B02',
    guest_id: 'guest-005',
    room_id: 'room-D102',
    booking_type: 'walk_in',
    is_bed_booking: true,
    bed_ids: ['bed-d102-4'],
    bed_count: 1,
    check_in: '2026-05-15T08:00:00Z',
    check_out: '2026-05-16T11:00:00Z',
    status: 'checked_in',
    deposit: 200,
    total_amount: 1000,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-15T08:05:00Z',
  },
  {
    id: 'bk-015',
    booking_id: 'HOTEL-20260516-B03',
    guest_id: 'guest-004',
    room_id: 'room-D101',
    booking_type: 'advance',
    is_bed_booking: true,
    bed_ids: ['bed-d101-5'],
    bed_count: 1,
    check_in: '2026-05-16T14:00:00Z',
    check_out: '2026-05-18T11:00:00Z',
    status: 'confirmed',
    deposit: 400,
    total_amount: 1200,
    pending_amount: 800,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-14T10:00:00Z',
  },
  {
    id: 'bk-016',
    booking_id: 'HOTEL-20260513-B04',
    guest_id: 'guest-001',
    room_id: 'room-D201',
    booking_type: 'walk_in',
    is_bed_booking: true,
    bed_ids: ['bed-d201-3'],
    bed_count: 1,
    check_in: '2026-05-13T12:00:00Z',
    check_out: '2026-05-15T11:00:00Z',
    status: 'checked_in',
    deposit: 300,
    total_amount: 800,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-13T12:05:00Z',
  },
  {
    id: 'bk-017',
    booking_id: 'HOTEL-20260514-B05',
    guest_id: 'guest-006',
    room_id: 'room-SH01',
    booking_type: 'advance',
    is_bed_booking: true,
    bed_ids: ['bed-sh01-1'],
    bed_count: 1,
    check_in: '2026-05-14T14:00:00Z',
    check_out: '2026-05-17T11:00:00Z',
    status: 'checked_in',
    deposit: 1000,
    total_amount: 3000,
    pending_amount: 0,
    extra_charges: [],
    cancellation_reason: '',
    refund_status: '',
    created_at: '2026-05-14T14:05:00Z',
  },
];

export const demoPayments: Payment[] = [
  { id: 'pay-001', booking_id: 'bk-001', amount: 4600, payment_method: 'upi', payment_type: 'full', receipt_no: 'RCP-20260515-001', created_by: 'usr-003', created_at: '2026-05-15T12:10:00Z' },
  { id: 'pay-002', booking_id: 'bk-002', amount: 2000, payment_method: 'card', payment_type: 'deposit', receipt_no: 'RCP-20260510-002', created_by: 'usr-004', created_at: '2026-05-10T09:05:00Z' },
  { id: 'pay-003', booking_id: 'bk-002', amount: 3200, payment_method: 'card', payment_type: 'full', receipt_no: 'RCP-20260514-003', created_by: 'usr-003', created_at: '2026-05-14T14:05:00Z' },
  { id: 'pay-004', booking_id: 'bk-004', amount: 13500, payment_method: 'cash', payment_type: 'full', receipt_no: 'RCP-20260515-004', created_by: 'usr-003', created_at: '2026-05-15T11:15:00Z' },
  { id: 'pay-005', booking_id: 'bk-005', amount: 1500, payment_method: 'online', payment_type: 'deposit', receipt_no: 'RCP-20260508-005', created_by: 'usr-003', created_at: '2026-05-08T10:30:00Z' },
  { id: 'pay-006', booking_id: 'bk-005', amount: 2700, payment_method: 'upi', payment_type: 'partial', receipt_no: 'RCP-20260515-006', created_by: 'usr-003', created_at: '2026-05-15T15:10:00Z' },
  { id: 'pay-007', booking_id: 'bk-006', amount: 5000, payment_method: 'card', payment_type: 'deposit', receipt_no: 'RCP-20260428-007', created_by: 'usr-003', created_at: '2026-04-28T14:05:00Z' },
  { id: 'pay-008', booking_id: 'bk-006', amount: 21200, payment_method: 'card', payment_type: 'full', receipt_no: 'RCP-20260515-008', created_by: 'usr-003', created_at: '2026-05-15T11:20:00Z' },
  { id: 'pay-009', booking_id: 'bk-007', amount: 2000, payment_method: 'cash', payment_type: 'deposit', receipt_no: 'RCP-20260512-009', created_by: 'usr-003', created_at: '2026-05-12T11:05:00Z' },
  { id: 'pay-010', booking_id: 'bk-008', amount: 15600, payment_method: 'upi', payment_type: 'full', receipt_no: 'RCP-20260514-010', created_by: 'usr-003', created_at: '2026-05-14T11:10:00Z' },
];

export const demoInventoryItems: InventoryItem[] = [
  { id: 'inv-001', name: 'Toilet Paper Roll', category: 'Housekeeping', unit: 'Rolls', min_stock_level: 50, current_qty: 120, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-002', name: 'Bed Sheet (King)', category: 'Linen', unit: 'Pieces', min_stock_level: 30, current_qty: 18, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-003', name: 'Bath Towel', category: 'Linen', unit: 'Pieces', min_stock_level: 40, current_qty: 55, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-004', name: 'Shampoo Sachet', category: 'Toiletries', unit: 'Pieces', min_stock_level: 200, current_qty: 85, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-005', name: 'Room Freshener', category: 'Housekeeping', unit: 'Cans', min_stock_level: 10, current_qty: 15, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-006', name: 'LED Bulb 9W', category: 'Electronics', unit: 'Pieces', min_stock_level: 20, current_qty: 8, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-007', name: 'Hand Wash Liquid', category: 'Toiletries', unit: 'Liters', min_stock_level: 10, current_qty: 12, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-008', name: 'Floor Cleaner', category: 'Housekeeping', unit: 'Liters', min_stock_level: 15, current_qty: 22, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-009', name: 'Pillow Cover', category: 'Linen', unit: 'Pieces', min_stock_level: 50, current_qty: 60, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-010', name: 'Garbage Bag (Large)', category: 'Housekeeping', unit: 'Rolls', min_stock_level: 20, current_qty: 5, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-011', name: 'AC Remote Battery', category: 'Electronics', unit: 'Pieces', min_stock_level: 30, current_qty: 45, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-012', name: 'Door Lock Handle', category: 'Furniture', unit: 'Pieces', min_stock_level: 5, current_qty: 3, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-013', name: 'Tea Sachets', category: 'Kitchen', unit: 'Boxes', min_stock_level: 10, current_qty: 7, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-014', name: 'Coffee Sachets', category: 'Kitchen', unit: 'Boxes', min_stock_level: 10, current_qty: 4, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-015', name: 'Sugar Packets', category: 'Kitchen', unit: 'Packets', min_stock_level: 100, current_qty: 250, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-016', name: 'A4 Paper', category: 'Office', unit: 'Reams', min_stock_level: 5, current_qty: 3, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-017', name: 'Pen (Blue)', category: 'Office', unit: 'Dozen', min_stock_level: 3, current_qty: 2, created_at: '2025-01-01T00:00:00Z' },
  { id: 'inv-018', name: 'Plumbing Tape', category: 'Maintenance', unit: 'Rolls', min_stock_level: 5, current_qty: 6, created_at: '2025-01-01T00:00:00Z' },
];

export const demoStockTransactions: StockTransaction[] = [
  { id: 'stx-001', item_id: 'inv-001', type: 'purchase', qty: 200, vendor_id: 'vnd-001', bill_no: 'PO-20260501', price: 4500, created_at: '2026-05-01T10:00:00Z' },
  { id: 'stx-002', item_id: 'inv-002', type: 'purchase', qty: 50, vendor_id: 'vnd-002', bill_no: 'PO-20260420', price: 12000, created_at: '2026-04-20T14:00:00Z' },
  { id: 'stx-003', item_id: 'inv-004', type: 'usage', qty: 150, dept: 'Housekeeping', reason: 'Daily room restocking', created_at: '2026-05-01T08:00:00Z' },
  { id: 'stx-004', item_id: 'inv-006', type: 'purchase', qty: 30, vendor_id: 'vnd-003', bill_no: 'PO-20260415', price: 3600, created_at: '2026-04-15T11:00:00Z' },
  { id: 'stx-005', item_id: 'inv-006', type: 'usage', qty: 22, dept: 'Maintenance', reason: 'Room replacements', created_at: '2026-05-01T09:00:00Z' },
  { id: 'stx-006', item_id: 'inv-010', type: 'adjustment', qty: -5, reason: 'Damaged stock disposal', created_at: '2026-05-10T16:00:00Z' },
  { id: 'stx-007', item_id: 'inv-012', type: 'purchase', qty: 5, vendor_id: 'vnd-004', bill_no: 'PO-20260505', price: 2500, created_at: '2026-05-05T10:00:00Z' },
  { id: 'stx-008', item_id: 'inv-013', type: 'purchase', qty: 15, vendor_id: 'vnd-005', bill_no: 'PO-20260508', price: 3000, created_at: '2026-05-08T14:00:00Z' },
  { id: 'stx-009', item_id: 'inv-013', type: 'usage', qty: 8, dept: 'Kitchen', reason: 'Guest room supplies', created_at: '2026-05-10T10:00:00Z' },
  { id: 'stx-010', item_id: 'inv-014', type: 'adjustment', qty: -2, reason: 'Expired stock', created_at: '2026-05-12T09:00:00Z' },
];

export const demoVendors: Vendor[] = [
  { id: 'vnd-001', name: 'Bharat Hygiene Supplies', contact: '+91 98765 11111', address: 'Warehouse 3, Industrial Area, Delhi', gstin: '07AABCU9603R1ZX', payment_terms: 'Net 15 days', created_at: '2025-01-01T00:00:00Z' },
  { id: 'vnd-002', name: 'Royal Linens Pvt Ltd', contact: '+91 98765 22222', address: 'Textile Park, Surat, Gujarat', gstin: '24AABCU9603R1ZY', payment_terms: 'Net 30 days', created_at: '2025-01-01T00:00:00Z' },
  { id: 'vnd-003', name: 'Bright Electronics', contact: '+91 98765 33333', address: 'Electronic Market, Bengaluru', gstin: '29AABCU9603R1ZZ', payment_terms: 'Cash on delivery', created_at: '2025-01-01T00:00:00Z' },
  { id: 'vnd-004', name: 'Secure Hardware Store', contact: '+91 98765 44444', address: 'Market Road, Mumbai', gstin: '27AABCU9603R1ZA', payment_terms: 'Net 7 days', created_at: '2025-01-01T00:00:00Z' },
  { id: 'vnd-005', name: 'Fresh Foods Distributors', contact: '+91 98765 55555', address: 'Food Park, Pune', gstin: '27AABCU9603R1ZB', payment_terms: 'Net 15 days', created_at: '2025-01-01T00:00:00Z' },
];

export const demoPurchaseOrders: PurchaseOrder[] = [
  {
    id: 'po-001',
    po_number: 'PO-20260501-001',
    vendor_id: 'vnd-001',
    order_date: '2026-05-01T10:00:00Z',
    expected_delivery: '2026-05-05',
    status: 'partial',
    items: [
      { item_id: 'inv-001', qty_ordered: 200, qty_received: 120, unit_price: 22.5 },
      { item_id: 'inv-005', qty_ordered: 20, qty_received: 20, unit_price: 85 },
      { item_id: 'inv-010', qty_ordered: 30, qty_received: 0, unit_price: 45 },
    ],
    total_amount: 9600,
    notes: 'Monthly housekeeping supplies',
    created_at: '2026-05-01T10:00:00Z',
  },
  {
    id: 'po-002',
    po_number: 'PO-20260420-002',
    vendor_id: 'vnd-002',
    order_date: '2026-04-20T14:00:00Z',
    expected_delivery: '2026-04-25',
    status: 'received',
    items: [
      { item_id: 'inv-002', qty_ordered: 50, qty_received: 50, unit_price: 240 },
      { item_id: 'inv-003', qty_ordered: 40, qty_received: 40, unit_price: 180 },
    ],
    total_amount: 19200,
    notes: 'Linen restock — all received',
    created_at: '2026-04-20T14:00:00Z',
  },
  {
    id: 'po-003',
    po_number: 'PO-20260415-003',
    vendor_id: 'vnd-003',
    order_date: '2026-04-15T11:00:00Z',
    expected_delivery: '2026-04-20',
    status: 'received',
    items: [
      { item_id: 'inv-006', qty_ordered: 30, qty_received: 30, unit_price: 120 },
    ],
    total_amount: 3600,
    notes: 'LED bulbs for rooms',
    created_at: '2026-04-15T11:00:00Z',
  },
  {
    id: 'po-004',
    po_number: 'PO-20260505-004',
    vendor_id: 'vnd-004',
    order_date: '2026-05-05T10:00:00Z',
    expected_delivery: '2026-05-08',
    status: 'ordered',
    items: [
      { item_id: 'inv-012', qty_ordered: 10, qty_received: 0, unit_price: 250 },
      { item_id: 'inv-018', qty_ordered: 15, qty_received: 0, unit_price: 35 },
    ],
    total_amount: 3025,
    notes: 'Hardware & maintenance supplies',
    created_at: '2026-05-05T10:00:00Z',
  },
  {
    id: 'po-005',
    po_number: 'PO-20260508-005',
    vendor_id: 'vnd-005',
    order_date: '2026-05-08T14:00:00Z',
    expected_delivery: '2026-05-12',
    status: 'ordered',
    items: [
      { item_id: 'inv-013', qty_ordered: 20, qty_received: 0, unit_price: 200 },
      { item_id: 'inv-014', qty_ordered: 15, qty_received: 0, unit_price: 180 },
      { item_id: 'inv-015', qty_ordered: 300, qty_received: 0, unit_price: 5 },
    ],
    total_amount: 8200,
    notes: 'Kitchen supplies — tea, coffee, sugar',
    created_at: '2026-05-08T14:00:00Z',
  },
  {
    id: 'po-006',
    po_number: 'PO-20260510-006',
    vendor_id: 'vnd-001',
    order_date: '2026-05-10T09:00:00Z',
    expected_delivery: '2026-05-15',
    status: 'ordered',
    items: [
      { item_id: 'inv-004', qty_ordered: 250, qty_received: 0, unit_price: 3.5 },
      { item_id: 'inv-007', qty_ordered: 20, qty_received: 0, unit_price: 65 },
    ],
    total_amount: 2175,
    notes: 'Toiletries — shampoo, hand wash',
    created_at: '2026-05-10T09:00:00Z',
  },
  {
    id: 'po-007',
    po_number: 'PO-20260512-007',
    vendor_id: 'vnd-004',
    order_date: '2026-05-12T16:00:00Z',
    expected_delivery: '2026-05-18',
    status: 'ordered',
    items: [
      { item_id: 'inv-016', qty_ordered: 10, qty_received: 0, unit_price: 220 },
      { item_id: 'inv-017', qty_ordered: 5, qty_received: 0, unit_price: 75 },
    ],
    total_amount: 2575,
    notes: 'Office stationery',
    created_at: '2026-05-12T16:00:00Z',
  },
];

export const demoGoodsReceivedNotes: GoodsReceivedNote[] = [
  {
    id: 'grn-001',
    grn_number: 'GRN-20260503-001',
    po_id: 'po-001',
    vendor_id: 'vnd-001',
    received_date: '2026-05-03T11:00:00Z',
    items: [
      { item_id: 'inv-001', qty_received: 120 },
      { item_id: 'inv-005', qty_received: 20 },
    ],
    bill_no: 'BH-2026-0515',
    bill_amount: 4400,
    notes: 'First delivery — Toilet paper partial, Room freshener complete. Garbage bags pending.',
    created_at: '2026-05-03T11:00:00Z',
  },
  {
    id: 'grn-002',
    grn_number: 'GRN-20260422-002',
    po_id: 'po-002',
    vendor_id: 'vnd-002',
    received_date: '2026-04-22T15:00:00Z',
    items: [
      { item_id: 'inv-002', qty_received: 50 },
      { item_id: 'inv-003', qty_received: 40 },
    ],
    bill_no: 'RL-2026-0418',
    bill_amount: 19200,
    notes: 'Complete delivery — all items received in full. Quality checked OK.',
    created_at: '2026-04-22T15:00:00Z',
  },
  {
    id: 'grn-003',
    grn_number: 'GRN-20260418-003',
    po_id: 'po-003',
    vendor_id: 'vnd-003',
    received_date: '2026-04-18T14:00:00Z',
    items: [
      { item_id: 'inv-006', qty_received: 30 },
    ],
    bill_no: 'BE-2026-0415',
    bill_amount: 3600,
    notes: 'All LED bulbs received. Tested — 2 faulty, being replaced by vendor.',
    created_at: '2026-04-18T14:00:00Z',
  },
];

export const demoCanteenItems: CanteenItem[] = [
  { id: 'cnt-001', name: 'Masala Dosa', category: 'Breakfast', price: 80, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-002', name: 'Idli Sambar', category: 'Breakfast', price: 60, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-003', name: 'Poori Bhaji', category: 'Breakfast', price: 70, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-004', name: 'Butter Chicken', category: 'Lunch', price: 280, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-005', name: 'Paneer Tikka', category: 'Lunch', price: 240, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-006', name: 'Dal Makhani', category: 'Lunch', price: 180, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-007', name: 'Grilled Fish', category: 'Dinner', price: 350, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-008', name: 'Biryani', category: 'Dinner', price: 220, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-009', name: 'Samosa', category: 'Snacks', price: 25, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-010', name: 'Vada Pav', category: 'Snacks', price: 30, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-011', name: 'Masala Chai', category: 'Beverages', price: 20, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-012', name: 'Cold Coffee', category: 'Beverages', price: 60, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-013', name: 'Fresh Lime Soda', category: 'Beverages', price: 40, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-014', name: 'Pav Bhaji', category: 'Special', price: 120, gst_percent: 5, available: true, created_at: '2025-01-01T00:00:00Z' },
  { id: 'cnt-015', name: 'Chole Bhature', category: 'Special', price: 110, gst_percent: 5, available: false, created_at: '2025-01-01T00:00:00Z' },
];

export const demoCanteenBills: CanteenBill[] = [
  {
    id: 'cb-001',
    bill_no: 'CNT-20260515-001',
    table_or_room: 'Room 101',
    items: [
      { item_id: 'cnt-004', name: 'Butter Chicken', qty: 2, price: 280, gst: 14 },
      { item_id: 'cnt-011', name: 'Masala Chai', qty: 4, price: 20, gst: 1 },
    ],
    subtotal: 640,
    gst_total: 32,
    discount: 0,
    discount_type: 'flat',
    total: 672,
    payment_method: 'room_charge',
    status: 'pending',
    created_at: '2026-05-15T13:30:00Z',
  },
  {
    id: 'cb-002',
    bill_no: 'CNT-20260515-002',
    table_or_room: 'Table 3',
    items: [
      { item_id: 'cnt-001', name: 'Masala Dosa', qty: 3, price: 80, gst: 4 },
      { item_id: 'cnt-012', name: 'Cold Coffee', qty: 3, price: 60, gst: 3 },
    ],
    subtotal: 420,
    gst_total: 21,
    discount: 10,
    discount_type: 'percent',
    total: 441,
    payment_method: 'upi',
    status: 'paid',
    created_at: '2026-05-15T09:15:00Z',
  },
  {
    id: 'cb-003',
    bill_no: 'CNT-20260515-003',
    table_or_room: 'Room 202',
    items: [
      { item_id: 'cnt-008', name: 'Biryani', qty: 1, price: 220, gst: 11 },
      { item_id: 'cnt-013', name: 'Fresh Lime Soda', qty: 2, price: 40, gst: 2 },
    ],
    subtotal: 300,
    gst_total: 15,
    discount: 0,
    discount_type: 'flat',
    total: 315,
    payment_method: 'room_charge',
    status: 'pending',
    created_at: '2026-05-15T20:00:00Z',
  },
  {
    id: 'cb-004',
    bill_no: 'CNT-20260515-004',
    table_or_room: 'Table 5',
    items: [
      { item_id: 'cnt-014', name: 'Pav Bhaji', qty: 2, price: 120, gst: 6 },
      { item_id: 'cnt-010', name: 'Vada Pav', qty: 2, price: 30, gst: 1.5 },
    ],
    subtotal: 300,
    gst_total: 15,
    discount: 0,
    discount_type: 'flat',
    total: 315,
    payment_method: 'cash',
    status: 'paid',
    created_at: '2026-05-15T12:45:00Z',
  },
  {
    id: 'cb-005',
    bill_no: 'CNT-20260514-005',
    table_or_room: 'Room 302',
    items: [
      { item_id: 'cnt-004', name: 'Butter Chicken', qty: 1, price: 280, gst: 14 },
      { item_id: 'cnt-006', name: 'Dal Makhani', qty: 1, price: 180, gst: 9 },
      { item_id: 'cnt-011', name: 'Masala Chai', qty: 2, price: 20, gst: 1 },
    ],
    subtotal: 500,
    gst_total: 25,
    discount: 0,
    discount_type: 'flat',
    total: 525,
    payment_method: 'room_charge',
    status: 'paid',
    created_at: '2026-05-14T19:30:00Z',
  },
  {
    id: 'cb-006',
    bill_no: 'CNT-20260515-006',
    table_or_room: 'Table 1',
    items: [
      { item_id: 'cnt-001', name: 'Masala Dosa', qty: 1, price: 80, gst: 4 },
      { item_id: 'cnt-002', name: 'Idli Sambar', qty: 1, price: 60, gst: 3 },
      { item_id: 'cnt-011', name: 'Masala Chai', qty: 1, price: 20, gst: 1 },
    ],
    subtotal: 160,
    gst_total: 8,
    discount: 0,
    discount_type: 'flat',
    total: 168,
    payment_method: 'cash',
    status: 'paid',
    created_at: '2026-05-15T08:30:00Z',
  },
];

export const demoActivityLogs: ActivityLog[] = [
  { id: 'log-001', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Check-in', entity_type: 'booking', entity_id: 'bk-001', details: { guest: 'Amitabh Verma', room: '101' }, created_at: '2026-05-15T12:05:00Z' },
  { id: 'log-002', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Payment Received', entity_type: 'payment', entity_id: 'pay-001', details: { amount: 4600, method: 'UPI' }, created_at: '2026-05-15T12:10:00Z' },
  { id: 'log-003', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Canteen Bill', entity_type: 'canteen_bill', entity_id: 'cb-001', details: { total: 672, room: '101' }, created_at: '2026-05-15T13:30:00Z' },
  { id: 'log-004', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Check-out', entity_type: 'booking', entity_id: 'bk-004', details: { guest: 'Ravi Shankar', room: '202', amount: 13500 }, created_at: '2026-05-15T11:15:00Z' },
  { id: 'log-005', user_id: 'usr-004', user_name: 'Amit Kumar', action: 'Shift Handover', entity_type: 'shift', entity_id: 'shift-001', details: { shift: 'Morning', collections: 7500 }, created_at: '2026-05-15T14:00:00Z' },
  { id: 'log-006', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Check-in', entity_type: 'booking', entity_id: 'bk-005', details: { guest: 'Neha Gupta', room: '302' }, created_at: '2026-05-15T15:10:00Z' },
  { id: 'log-007', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Payment Received', entity_type: 'payment', entity_id: 'pay-006', details: { amount: 2700, method: 'UPI' }, created_at: '2026-05-15T15:10:00Z' },
  { id: 'log-008', user_id: 'usr-004', user_name: 'Amit Kumar', action: 'New Booking', entity_type: 'booking', entity_id: 'bk-012', details: { guest: 'Neha Gupta', room: '504' }, created_at: '2026-05-10T14:00:00Z' },
  { id: 'log-009', user_id: 'usr-004', user_name: 'Amit Kumar', action: 'Stock Purchase', entity_type: 'inventory', entity_id: 'stx-008', details: { item: 'Tea Sachets', qty: 15 }, created_at: '2026-05-08T14:00:00Z' },
  { id: 'log-010', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Canteen Bill', entity_type: 'canteen_bill', entity_id: 'cb-004', details: { total: 315, table: '5' }, created_at: '2026-05-15T12:45:00Z' },
  { id: 'log-011', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Check-in', entity_type: 'booking', entity_id: 'bk-003', details: { guest: 'Mohammed Ali', room: '102' }, created_at: '2026-05-15T08:35:00Z' },
  { id: 'log-012', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Room Status Update', entity_type: 'room', entity_id: 'room-103', details: { from: 'occupied', to: 'cleaning' }, created_at: '2026-05-15T10:00:00Z' },
  { id: 'log-013', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Bed Check-in', entity_type: 'bed_booking', entity_id: 'bb-002', details: { guest: 'Mohammed Ali', room: 'D102', bed: 'Bed 4' }, created_at: '2026-05-15T08:10:00Z' },
  { id: 'log-014', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Bed Booking', entity_type: 'bed_booking', entity_id: 'bb-003', details: { guest: 'Neha Gupta', room: 'D101', bed: 'Bed 5' }, created_at: '2026-05-15T09:45:00Z' },
  { id: 'log-015', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Bed Check-in', entity_type: 'bed_booking', entity_id: 'bb-001', details: { guest: 'Ravi Shankar', room: 'D101', bed: 'Beds 2,3,4' }, created_at: '2026-05-14T12:10:00Z' },
  { id: 'log-016', user_id: 'usr-004', user_name: 'Amit Kumar', action: 'Bed Check-out', entity_type: 'bed_booking', entity_id: 'bb-004', details: { guest: 'Amitabh Verma', room: 'D201', bed: 'Bed 3' }, created_at: '2026-05-15T11:05:00Z' },
  { id: 'log-017', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Bed Booking', entity_type: 'bed_booking', entity_id: 'bb-005', details: { guest: 'Deepa Krishnan', room: 'SH01', bed: 'Bed 1' }, created_at: '2026-05-14T14:10:00Z' },
  { id: 'log-018', user_id: 'usr-003', user_name: 'Priya Patel', action: 'Dormitory Check-in', entity_type: 'bed_booking', entity_id: 'bb-001', details: { guest: 'Ravi Shankar', room: 'D101', bed: 'Beds 2,3,4' }, created_at: '2026-05-14T12:05:00Z' },
];